// extracted by mini-css-extract-plugin
export var container = "styles-module--container--65d55";
export var content = "styles-module--content--79be6";
export var textContainer = "styles-module--textContainer--e6af4";
export var title = "styles-module--title--affbc";